/* Umikagan interactions: Splide 4.1.4 + Lenis 1.3.18 + jQuery 3.7.1. */
(() => {
  'use strict';
  const reduced=matchMedia('(prefers-reduced-motion: reduce)');
  const mobile=matchMedia('(max-width: 767px)');
  const header=document.querySelector('.site-header');
  const topLink=document.querySelector('.back-to-top');
  const status=document.querySelector('.status');
  const instances=[];
  const boot=window.umikaganPage;
  let pageReady=!document.documentElement.classList.contains('is-loading');
  const canAutoplay=()=>pageReady&&!reduced.matches;
  let lenis,zoomMotion,parallaxFrame,modalReturn;
  const setupScroll=()=>{
    lenis?.destroy();lenis=undefined;
    if(!reduced.matches&&!mobile.matches&&window.Lenis){
      lenis=new Lenis({autoRaf:true,lerp:.1,smoothWheel:true,syncTouch:false,anchors:false,prevent:node=>Boolean(node.closest('dialog'))});
    }
  };
  document.body.classList.add('has-scroll');
  const syncScroll=()=>{
    header.classList.toggle('is-fixed',scrollY>70);
    topLink.classList.toggle('is-visible',scrollY>320);
  };
  addEventListener('scroll',syncScroll,{passive:true});syncScroll();
  document.addEventListener('click',event=>{
    const anchor=event.target.closest('a[href^="#"]');
    if(!anchor)return;
    const target=document.querySelector(anchor.getAttribute('href'));
    if(!target)return;
    if(target.tagName==='DIALOG'){event.preventDefault();modalReturn=anchor;target.showModal();lenis?.stop();return;}
    event.preventDefault();
    const y=Math.max(0,target.getBoundingClientRect().top+scrollY-(mobile.matches?75:90));
    const focus=()=>{
      const focusable=target.matches('a,button,input,summary,[tabindex]');
      if(!focusable)target.setAttribute('tabindex','-1');
      target.focus({preventScroll:true});
      if(!focusable)target.addEventListener('blur',()=>target.removeAttribute('tabindex'),{once:true});
    };
    history.replaceState(null,'',anchor.hash);
    if(lenis)lenis.scrollTo(y,{duration:.9,onComplete:focus});
    else{scrollTo({top:y,behavior:reduced.matches?'instant':'smooth'});focus();}
  });
  const inviewElements=[...document.querySelectorAll('[data-inview]')];
  const startReveals=()=>{if('IntersectionObserver' in window){
    const revealObserver=new IntersectionObserver(entries=>{
      entries.forEach(entry=>{
        if(!entry.isIntersecting)return;
        if(!reduced.matches)entry.target.animate([{opacity:0,translate:'0 50px'},{opacity:1,translate:'0 0'}],{duration:1100,easing:'cubic-bezier(.25,1,.5,1)'});
        revealObserver.unobserve(entry.target);
      });
    },{rootMargin:'0px 0px -4% 0px',threshold:.08});
    inviewElements.forEach(el=>{
      const rect=el.getBoundingClientRect();
      if(rect.bottom>0&&rect.top<innerHeight)return;
      revealObserver.observe(el);
    });
  }};
  const hero=document.querySelector('.hero');
  const heroImage=hero.querySelector('.hero-background img');
  const heroMotionToggle=hero.querySelector('.hero-motion-toggle');
  let heroVisible=true,heroPaused=false;
  const syncHeroMotion=()=>{
    if(!zoomMotion)return;
    if(!pageReady||heroPaused||!heroVisible||document.visibilityState==='hidden')zoomMotion.pause();
    else zoomMotion.play();
  };
  const motion=()=>{
    zoomMotion?.cancel();zoomMotion=undefined;
    const enabled=!reduced.matches&&typeof heroImage.animate==='function';
    heroMotionToggle.hidden=!enabled;
    if(!enabled)return;
    zoomMotion=heroImage.animate([{transform:'scale(1)'},{transform:'scale(1.12)'}],{duration:24000,iterations:Infinity,direction:'alternate',easing:'cubic-bezier(.37,0,.63,1)',fill:'both'});
    syncHeroMotion();
  };
  heroMotionToggle.addEventListener('click',()=>{
    heroPaused=!heroPaused;
    const label=heroPaused?'背景の動きを再開する':'背景の動きを止める';
    heroMotionToggle.setAttribute('aria-label',label);heroMotionToggle.title=label;
    heroMotionToggle.setAttribute('aria-pressed',String(heroPaused));
    syncHeroMotion();
  });
  document.addEventListener('visibilitychange',syncHeroMotion);
  if('IntersectionObserver' in window)new IntersectionObserver(entries=>{
    heroVisible=entries[0].isIntersecting;syncHeroMotion();
  },{threshold:0}).observe(hero);
  motion();
  const updateParallax=()=>{
    if(reduced.matches||mobile.matches)return;
    const banner=document.querySelector('.details-banner'),r=banner.getBoundingClientRect();
    if(r.bottom>0&&r.top<innerHeight){const y=(r.top+r.height/2-innerHeight/2)*.18;banner.querySelector('.banner-background').style.transform=`translateY(${y}px)`;}
  };
  addEventListener('scroll',()=>{if(!parallaxFrame)parallaxFrame=requestAnimationFrame(()=>{parallaxFrame=0;updateParallax();});},{passive:true});
  if(window.Splide){
    const i18n={prev:'前の写真',next:'次の写真',first:'最初の写真',last:'最後の写真',slideX:'写真 %s',pageX:'%sページ目',play:'再生',pause:'停止',select:'表示する写真を選択',slide:'写真',slideLabel:'%s枚目 / %s枚'};
    const mount=(id,options)=>{
      const element=document.getElementById(id);
      const slider=new Splide(element,{i18n,keyboard:'focused',pauseOnFocus:true,pauseOnHover:true,reducedMotion:{speed:0,rewindSpeed:0,autoplay:'pause'},...options});
      slider.mount();instances.push(slider);return slider;
    };
    const ticker=mount('hero-ticker',{type:'fade',rewind:true,arrows:false,pagination:false,autoplay:canAutoplay(),interval:6000,speed:800,easing:'cubic-bezier(.25,1,.5,1)'});
    ['concept','gift'].forEach(name=>{
      const main=mount(`${name}-main`,{type:'loop',perPage:1,arrows:true,pagination:false,autoplay:canAutoplay(),interval:6500,speed:1400,easing:'cubic-bezier(.25,1,.5,1)',breakpoints:{767:{arrows:false}}});
      const inset=mount(`${name}-inset`,{type:'fade',rewind:true,arrows:false,pagination:true,autoplay:canAutoplay(),interval:6500,speed:1000,easing:'cubic-bezier(.25,1,.5,1)'});
      let animationFrame,moving=false;
      const placeImages=()=>{
        const track=main.root.querySelector('.splide__track').getBoundingClientRect();
        main.root.querySelectorAll('.splide__slide').forEach(slide=>{
          const image=slide.querySelector('.slide-image');
          if(reduced.matches||mobile.matches){image.style.transform='';return;}
          const progress=(slide.getBoundingClientRect().left-track.left)/track.width;
          image.style.transform=`translateX(${-progress*70}%)`;
        });
        if(moving)animationFrame=requestAnimationFrame(placeImages);
      };
      main.on('move drag',()=>{moving=true;cancelAnimationFrame(animationFrame);placeImages();});
      main.on('moved dragged',()=>{moving=false;cancelAnimationFrame(animationFrame);placeImages();});
      main.on('resize refresh',placeImages);placeImages();
      if('IntersectionObserver' in window){
        new IntersectionObserver(entries=>entries.forEach(entry=>{
          [main,inset].forEach(slider=>{if(entry.isIntersecting&&canAutoplay())slider.Components.Autoplay.play();else slider.Components.Autoplay.pause();});
        }),{threshold:.05}).observe(main.root);
      }
    });
    const sets=mount('shop-slider',{type:'slide',perPage:2,gap:40,arrows:false,pagination:true,autoplay:false,speed:800,breakpoints:{767:{perPage:1,gap:20}}});
    const labelSets=()=>sets.root.querySelectorAll('.splide__pagination__page').forEach((button,index)=>{const name=['水 × オレンジ','白の酒器'][index];button.textContent=name;button.setAttribute('aria-label',name+'のセットを表示');});
    sets.on('pagination:mounted',labelSets);labelSets();
    sets.on('resized',()=>{if(!mobile.matches)sets.go(0);});
    mount('spec-slider',{type:'slide',perPage:3,gap:35,arrows:false,pagination:false,autoplay:false,speed:800,breakpoints:{767:{perPage:1,fixedWidth:250,gap:20,padding:{left:20,right:20}}}});
    document.addEventListener('visibilitychange',()=>{if(document.hidden)instances.forEach(slider=>slider.Components.Autoplay?.pause());else if(canAutoplay())ticker.Components.Autoplay.play();});
  }
  const searchToggle=document.querySelector('.search-toggle');
  const searchForm=document.querySelector('#search-form');
  const toggleSearch=()=>{searchForm.hidden=!searchForm.hidden;searchToggle.setAttribute('aria-expanded',String(!searchForm.hidden));if(!searchForm.hidden)searchForm.querySelector('input').focus();};
  // Search also works when jQuery is unavailable.
  if(window.jQuery)jQuery(searchToggle).on('click',toggleSearch);else searchToggle.addEventListener('click',toggleSearch);
  const save=document.querySelector('.save-product');
  try{save.setAttribute('aria-pressed',String(localStorage.getItem('umikagan-saved')==='true'));}catch{}
  save.addEventListener('click',()=>{const active=save.getAttribute('aria-pressed')!=='true';save.setAttribute('aria-pressed',String(active));try{localStorage.setItem('umikagan-saved',String(active));}catch{}status.textContent=active?'このブラウザーに海かがんを保存しました。':'商品の保存を解除しました。';});
  const menu=document.querySelector('.menu-dialog');
  const menuToggle=document.querySelector('.menu-toggle');
  const closeMenu=()=>{menu.close();menuToggle.setAttribute('aria-expanded','false');lenis?.start();menuToggle.focus({preventScroll:true});};
  menuToggle.addEventListener('click',()=>{menu.showModal();menuToggle.setAttribute('aria-expanded','true');lenis?.stop();});
  menu.querySelector('.menu-close').addEventListener('click',closeMenu);
  menu.addEventListener('cancel',()=>{menuToggle.setAttribute('aria-expanded','false');lenis?.start();});
  menu.addEventListener('close',()=>{menuToggle.setAttribute('aria-expanded','false');lenis?.start();});
  menu.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>{menu.close();menuToggle.setAttribute('aria-expanded','false');lenis?.start();}));
  document.addEventListener('keydown',event=>{if(event.key==='Escape'&&!searchForm.hidden){searchForm.hidden=true;searchToggle.setAttribute('aria-expanded','false');searchToggle.focus();}});
  const dialog=document.querySelector('.photo-dialog');
  const care=document.querySelector('.care-dialog');
  care.querySelector('.care-close').addEventListener('click',()=>care.close());
  care.addEventListener('close',()=>{lenis?.start();modalReturn?.focus({preventScroll:true});});
  const zoomButton=dialog.querySelector('.photo-zoom');
  const resetZoom=()=>{dialog.classList.remove('is-zoomed');zoomButton.textContent='2倍で見る ＋';zoomButton.setAttribute('aria-pressed','false');};
  document.addEventListener('click',event=>{
    const link=event.target.closest('.photo-open');if(!link||!dialog.showModal)return;
    event.preventDefault();modalReturn=link;resetZoom();
    const current=link.querySelector('img');const full=dialog.querySelector('img');
    full.src=link.href;full.alt=current.alt;full.width=current.width;full.height=current.height;
    dialog.querySelector('#photo-title').textContent=current.alt;
    dialog.showModal();lenis?.stop();
  });
  dialog.querySelector('.photo-close').addEventListener('click',()=>dialog.close());
  dialog.addEventListener('close',()=>{lenis?.start();modalReturn?.focus({preventScroll:true});});
  zoomButton.addEventListener('click',()=>{const active=dialog.classList.toggle('is-zoomed');zoomButton.setAttribute('aria-pressed',String(active));zoomButton.textContent=active?'全体に戻す −':'2倍で見る ＋';const frame=dialog.querySelector('.photo-frame');frame.scrollLeft=active?(frame.scrollWidth-frame.clientWidth)/2:0;frame.scrollTop=active?(frame.scrollHeight-frame.clientHeight)/2:0;});
  [dialog,menu,care].forEach(modal=>modal.addEventListener('click',event=>{if(event.target!==modal)return;const r=modal.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)modal.close();}));
  const adapt=()=>{
    setupScroll();motion();
    if(reduced.matches){instances.forEach(s=>s.Components.Autoplay?.pause());document.querySelectorAll('[data-inview]').forEach(e=>e.getAnimations().forEach(a=>a.cancel()));document.querySelector('.banner-background').style.transform='';}
    if(document.querySelector('dialog[open]'))lenis?.stop();
  };
  reduced.addEventListener('change',adapt);mobile.addEventListener('change',adapt);
  const positionPage=()=>{
    setupScroll();
    lenis?.scrollTo(scrollY,{immediate:true,force:true});
    syncScroll();updateParallax();
  };
  const activatePage=()=>{
    pageReady=true;syncHeroMotion();startReveals();
    if(!canAutoplay()||document.hidden)return;
    instances.forEach(slider=>{
      if(!/^(hero-ticker|concept-(main|inset)|gift-(main|inset))$/.test(slider.root.id))return;
      const rect=slider.root.getBoundingClientRect();
      if(rect.bottom>0&&rect.top<innerHeight)slider.Components.Autoplay?.play();
    });
  };
  addEventListener('umikagan:position',positionPage,{once:true});
  addEventListener('umikagan:ready',activatePage,{once:true});
  const within=(promise,ms)=>Promise.race([promise,new Promise(resolve=>setTimeout(resolve,ms))]);
  const preparePage=async()=>{
    if(!boot||boot.ready){positionPage();activatePage();return;}
    if(document.fonts)await within(document.fonts.ready,1200);
    const top=boot.targetY();
    const images=[...document.images].filter(img=>{
      const rect=img.getBoundingClientRect();
      return rect.width>0&&rect.height>0&&rect.right>0&&rect.left<innerWidth&&rect.bottom+scrollY>top&&rect.top+scrollY<top+innerHeight;
    });
    await within(Promise.allSettled(images.map(async img=>{
      img.loading='eager';
      if(!img.complete)await new Promise(resolve=>{img.addEventListener('load',resolve,{once:true});img.addEventListener('error',resolve,{once:true});});
      if(img.naturalWidth&&img.decode)await img.decode().catch(()=>{});
    })),4500);
    await new Promise(resolve=>requestAnimationFrame(()=>requestAnimationFrame(resolve)));
    boot.finish();
  };
  preparePage().catch(()=>boot?.finish('fallback'));
})();
